import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import {  Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SurveyService } from 'app/core/survey/survey.service';
import { InitialData } from './survey.types';

@Injectable({
    providedIn: 'root'
})
export class SurveyDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(private _surveyService: SurveyService, private router: Router) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<InitialData> {
        // API call to get surveys llst
        return this._surveyService.getSurveysInitial()
            .pipe(
                map((surveys) => ({
                    surveys
                })
                ),
                catchError(err => {
                    this._surveyService.errorMessage = err.error.message ? err.error.message : "Something went wrong !";
                    return of(new DefaultResponse().surveys);
                })
            );
    }

}

class DefaultResponse implements InitialData {
    surveys: any = [];
}